import { Component, AfterViewInit, OnInit, OnDestroy, NgZone, ViewChild, ChangeDetectorRef,  } from '@angular/core';
import { Router, ActivatedRoute, } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import {
  TdLoadingService,
  TdMediaService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
  TdDataTableComponent,
} from '@covalent/core';

import { Alergia } from '../../../models';

import { AlergiasService, LoginService, } from '../../../services/';

@Component({
  selector: 'qs-alergias',
  templateUrl: './alergias.component.html',
  styleUrls: ['./alergias.component.scss'],
  providers: [AlergiasService],
})
export class AlergiasComponent implements AfterViewInit, OnInit, OnDestroy {

  private idPaciente: string;
  private alergias: any;

  private isSmallScreen: boolean = false;
  private _querySubscription: Subscription;

  // ITDdDataTableComponent
  // Columnas
  private columnsAll: ITdDataTableColumn[] = [
    { name: 'codigo', label: 'Código', tooltip: 'Código', sortable: true },
    { name: 'medicamento', label: 'Medicamento', hidden: true },
    { name: 'idAlergiaUsuario', label: 'idAlergiaUsuario', hidden: true },
    { name: 'descripcion', label: 'Descripcion', tooltip: 'Estado', sortable: true },
    { name: 'cpfNombreComponente', label: 'P.A.', tooltip: 'Principio Activo', sortable: false },
    { name: 'sospecha', label: 'Sospecha', tooltip: 'Sospecha', sortable: false },
    { name: 'fecha', label: 'Fecha', tooltip: 'Fecha', sortable: false },
    { name: 'dniMedico', label: 'DNI Médico', hidden: true },
    { name: 'cpfIdComponente', label: 'P.A.', hidden: true },
    { name: 'cip', label: 'CIP', hidden: true },
    { name: 'numeroExpediente', label: 'Num. Expediente', hidden: true },
    { name: 'visita', label: 'Num. Visita', hidden: true },
    { name: 'idModulo', label: 'Id Modulo', hidden: true },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  private filteredData: any[] = [];
  private filteredDataTotal: number;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'fecha';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

  @ViewChild(TdDataTableComponent) tableComponent: TdDataTableComponent;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _alergiasService: AlergiasService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService, ) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.watchScreen();
    this._titleService.setTitle('Alergias');
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('alergias.load');
    this._alergiasService.obtenerAlergias(this.idPaciente).subscribe((res: any) => {
      this.alergias = res.respuesta.alergias || [];
      this.filteredData = this.alergias;
      this.filteredDataTotal = this.alergias.length;
      this._loadingService.resolve('alergias.load');
    }, (error: Error) => {
      this._loadingService.resolve('alergias.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this.watchScreen();
  }

  /**
   * watchScreen:
   * Observable de cambio de resolució. Oculta o muestra columnas
   */
  watchScreen(): void {
    this._querySubscription = this.media.registerQuery('xs').subscribe((matches: boolean) => {
      this._ngZone.run(() => {
        if (matches) {
          // Ocultamos columnas
          this.columns[0].hidden = true;
          this.columns[4].hidden = true;
        } else {
          // Mostramos columnas
          this.columns[0].hidden = false;
          this.columns[4].hidden = false;
        }
      });
    });
  }

  /**
   * openDetail: Muestra la vista de detalle pasando la linea seccionada
   * @param any: $event <- Fila seleccionada
   */
  openDetail(alergia: Alergia): void {
    if (alergia) {
      this._loginService.transient = alergia;
      this._router.navigate(['editar/', alergia.idAlergiaUsuario], { relativeTo: this._route });
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.alergias;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

  ngOnDestroy(): void {
    this._querySubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/alergias/alergias.component.ts